// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"404e557b","174":"8a308a5b","261":"a30573c5","332":"f9efbbbe","718":"a364abe1","720":"219ce438","750":"a5f5e499","787":"de15b020","874":"8c65dab9","954":"933da905","967":"15075c3e","975":"e2c4b528","995":"4aeed738"}[chunkId] + ".chunk.js";
};